import React, { useEffect, useState } from 'react'
import { Heading, Text } from '../../components/ui'
import { PermissionGuard } from '../../components/PermissionGuard'
import { modulesService } from '../../services/modules'
import ContatosPortalDashboardTab from './ContatosPortalDashboardTab'
import ContatosPortalHistoricoTab from './ContatosPortalHistoricoTab'
import ContatosPortalDiarioTab from './ContatosPortalDiarioTab'
import ContatosPortalFormulariosRespostasTab from './ContatosPortalFormulariosRespostasTab'

const MODULE_NAME = 'comercial_contatos_portal'

type ActiveTab = 'dashboard' | 'contatos' | 'diario' | 'respostas_formularios'

const ComercialContatosPortal: React.FC = () => {
  const [activeTab, setActiveTab] = useState<ActiveTab>('dashboard')
  const [moduleTitle, setModuleTitle] = useState('Contatos realizados WIZ')
  const [moduleDescription, setModuleDescription] = useState(
    'Relatório de contatos e diário do portal de atendimento'
  )

  useEffect(() => {
    const loadModuleInfo = async () => {
      try {
        const result = await modulesService.getByName(MODULE_NAME)
        if (result.success && result.data) {
          if (result.data.display_name) {
            setModuleTitle(result.data.display_name)
          }
          if (result.data.description) {
            setModuleDescription(result.data.description)
          }
        }
      } catch (error) {
        console.error('Erro ao buscar informações do módulo:', error)
      }
    }

    void loadModuleInfo()
  }, [])

  const tabClass = (tab: ActiveTab) =>
    `py-3 px-1 border-b-2 font-medium text-sm ${
      activeTab === tab
        ? 'border-primary-600 text-primary-600 dark:text-primary-400'
        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-200'
    }`

  return (
    <div className="flex-1 flex flex-col overflow-x-hidden overflow-y-auto">
        <PermissionGuard
          moduleName={MODULE_NAME}
          permissionType="show"
          fallback={
            <div className="flex-1 flex items-center justify-center">
              <div className="text-center">
                <Text size="xl" className="mb-2 text-gray-500 dark:text-gray-400">
                  Acesso Negado
                </Text>
                <Text size="sm" color="muted">
                  Você não tem permissão para acessar esta página.
                </Text>
              </div>
            </div>
          }
        >
          <div className="h-full flex flex-col">
            <div className="p-6 border-b border-gray-200 dark:border-gray-700">
              <Heading as="h1" size="3xl" className="text-gray-900 dark:text-white">
                {moduleTitle}
              </Heading>
              <Text size="sm" color="muted" className="mt-1">
                {moduleDescription}
              </Text>
            </div>

            <div className="px-6 pt-4 border-b border-gray-200 dark:border-gray-700">
              <div className="border-b border-gray-200 dark:border-gray-700">
                <nav className="-mb-px flex space-x-8">
                  <button
                    type="button"
                    onClick={() => setActiveTab('dashboard')}
                    className={tabClass('dashboard')}
                  >
                    Dashboard
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab('contatos')}
                    className={tabClass('contatos')}
                  >
                    Contatos
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab('diario')}
                    className={tabClass('diario')}
                  >
                    Diário
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab('respostas_formularios')}
                    className={tabClass('respostas_formularios')}
                  >
                    Respostas de Formulários
                  </button>
                </nav>
              </div>
            </div>

            {activeTab === 'dashboard' && <ContatosPortalDashboardTab />}
            {activeTab === 'contatos' && <ContatosPortalHistoricoTab />}
            {activeTab === 'diario' && <ContatosPortalDiarioTab />}
            {activeTab === 'respostas_formularios' && <ContatosPortalFormulariosRespostasTab />}
          </div>
        </PermissionGuard>
    </div>
  )
}

export default ComercialContatosPortal
